var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketSubmissionSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 207,
    viewBox: "0 0 213 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.3599 20.3135C145.278 20.3135 183.372 58.4075 183.372 105.326C183.372 152.244 145.278 190.338 98.3599 190.338C51.4417 190.338 13.3477 152.244 13.3477 105.326C13.3477 58.4075 51.4417 20.3135 98.3599 20.3135Z",
    stroke: "#95CBB2",
    strokeWidth: 9.53525
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.25 111.684L80.7703 135.205L138.194 77.7812",
    stroke: "#95CBB2",
    strokeWidth: 10.5947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.711 30.4036C164.939 26.1759 168.669 22.4453 168.669 22.4453",
    stroke: "#95CBB2",
    strokeWidth: 8.94873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.176 59.0856C191.404 54.8575 195.134 51.127 195.134 51.127",
    stroke: "#95CBB2",
    strokeWidth: 8.94873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.672 37.8196C189.099 29.5682 196.534 22.2871 196.534 22.2871",
    stroke: "#95CBB2",
    strokeWidth: 8.94873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSubmissionSuccess);
export default __webpack_public_path__ + "static/media/ticket-submission-success.c9cb17a0bb8a821fdf00b5e439bfc257.svg";
export { ForwardRef as ReactComponent };